module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kbx-step",
    style: (_vm.getStyle())
  }, [(_vm.stepListHasJumps) ? _c('percent') : _c('numeric')], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-126134bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/progressbar/Main.vue
 ** module id = 766
 ** module chunks = 1
 **/